var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a-modal', {
    attrs: {
      "width": 900,
      "maskClosable": false,
      "keyboard": false,
      "visible": _vm.visible
    },
    on: {
      "cancel": _vm.start
    }
  }, [_c('h2', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("报名须知")]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-checkbox', {
    on: {
      "change": _vm.change
    }
  }, [_vm._v("\n      我已阅读并知悉以上内容\n    ")]), _c('a-divider', {
    attrs: {
      "type": "vertical"
    }
  }), _c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.start
    }
  }, [_vm._v("开始报名")])], 1), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };